import { defineMessages } from 'react-intl'

const scope = `procurify.platform.iam.components.ReportAccessUserSelect`

export default defineMessages({
  ariaLabel: {
    id: `${scope}.ariaLabel`,
    defaultMessage: 'Search users',
  },
  placeholder: {
    id: `${scope}.placeholder`,
    defaultMessage: 'Search users...',
  },
  noOptionsMessage: {
    id: `${scope}.noOptionsMessage`,
    defaultMessage: 'No users match your search',
  },
  loadErrorMessage: {
    id: `${scope}.loadErrorMessage`,
    defaultMessage: 'Unable to load users. Please try again.',
  },
})
